var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29683 8.44483C4.06809 8.20506 3.6883 8.19612 3.44853 8.42486C3.20877 8.65359 3.19983 9.03339 3.42856 9.27315L5.81028 11.7697C6.05552 12.0268 6.46919 12.0156 6.70023 11.7457L12.4276 5.05463C12.6431 4.80289 12.6137 4.42413 12.362 4.20865C12.1103 3.99316 11.7315 4.02256 11.516 4.2743L6.5081 10.1248C6.35407 10.3048 6.07829 10.3122 5.9148 10.1408L4.29683 8.44483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckIcon);
export default __webpack_public_path__ + "static/media/checkboxCheckIcon.fb26fb5fc9889c1afcf8fe83063ab013.svg";
export { ForwardRef as ReactComponent };